<template>
  <base-modal title="" :show-header="false" :width="340">
    <div class="audio-info">
      <svg-icon
        width="100"
        height="100"
        icon="app-icons/audio-note"
        fill="#DB841E"
      />
      <div class="header">This experience includes audio.</div>
      <div class="content">
        {{ content }}
      </div>
      <button class="button" @click="onCloseModal">
        <span class="text">Close</span>
      </button>
    </div>
  </base-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseModal from './BaseModal.vue';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    BaseModal,
    SvgIcon,
  },

  data() {
    return {
      content:
        'You may adjust the volume or turn off sounds completely from the top navigation bar.',
      onClose: null,
    };
  },

  computed: {
    ...mapGetters('application/modals', ['getPrototypeAudioModal']),
  },

  mounted() {
    const { onClose, content } = this.getPrototypeAudioModal;
    if (content) {
      this.content = content;
    }
    this.onClose = onClose;
  },

  methods: {
    ...mapActions('application/modals', ['setPrototypeAudioModal']),

    onCloseModal() {
      this.setPrototypeAudioModal({ value: null });
      if (this.onClose) {
        this.onClose();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  gap: 25px;

  .button {
    padding: 10px 18px;
    border-radius: 3px;
    border: none;
    color: #fff;
    background: #db841e;
    cursor: pointer;
    margin: 0;
    display: inline-block;
    width: 280px;
    text-align: center;
    position: relative;
    transition: background 0.25s;
    font-size: 17px;

    span {
      white-space: nowrap;
      display: block;
    }

    &:hover {
      background: #ce750d;
    }

    &:active {
      top: 1px;
    }
  }

  .header {
    font-weight: 600;
    font-size: 28px;
    line-height: 1.3;
    text-align: center;
    color: #ffffff;
  }

  .content {
    text-align: center;
    font-size: 17px;
    line-height: 1.5;
  }
}
</style>
